import { experience, expertise, profile } from "../data/profile";
import "../styles/About.css";

const About = () => (
  <div className="page">
    <header className="page-head animate-in">
      <h1 className="page-head__title">
        About <span className="gradient-text">me</span>
      </h1>
      <p className="lede">{profile.tagline}</p>
    </header>

    <section className="section">
      <h2 className="section-label">Introduction</h2>
      <div className="prose animate-in stagger-1">
        {profile.bio.map((paragraph) => (
          <p key={paragraph}>{paragraph}</p>
        ))}
      </div>
    </section>

    <section className="section">
      <h2 className="section-label">Expertise</h2>
      <div className="expertise-cards">
        {expertise.map(({ area, tools }, i) => (
          <article
            key={area}
            className={`glass-card expertise-card animate-in stagger-${i + 1}`}
          >
            <h3 className="expertise-card__title">{area}</h3>
            <div className="expertise-card__tools">
              {tools.map((tool) => (
                <span key={tool} className="tag">
                  {tool}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>

    <section className="section">
      <h2 className="section-label">Experience</h2>
      <ol className="timeline">
        {experience.map(({ company, start, end }, i) => (
          <li key={company} className={`timeline__item animate-in stagger-${i + 1}`}>
            <span className="timeline__dot" aria-hidden="true" />
            <div className="timeline__body">
              <h3 className="timeline__company">{company}</h3>
              <span className="timeline__dates">
                {start} — {end}
              </span>
            </div>
          </li>
        ))}
      </ol>
    </section>

    <section className="section">
      <h2 className="section-label">Background</h2>
      <p className="lede animate-in stagger-1">{profile.education}</p>
    </section>
  </div>
);

export default About;
